<div class="dropstart">
  <button
    class="btn"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
  >
    <h4 class="nav-link m-0 p-0">{{ prefix + localeId | msg | async }}</h4>
    <svg-icon
      src="../../../assets/images/icons/arrow-down.svg"
      [svgStyle]="{ 'width.px': 25, 'height.px': 25 }"
    ></svg-icon>
  </button>
  <ul class="dropdown-menu">
    <li *ngFor="let lang of availableLocales">
      <button
        class="dropdown-item"
        [class.active]="lang === localeId"
        (click)="changeLanguage(lang)"
      >
        {{ prefix + lang | msg | async }}
      </button>
    </li>
  </ul>
</div>
